import { Observable } from 'rxjs/Rx';
import { Component, OnInit, Output } from '@angular/core';
import { GroupService, ModuleService } from '../../../mesc.service';
import { Group } from '../../../../../shared/model';
import { Validators, FormBuilder } from '@angular/forms';
import { BaseGridTemplate } from '../../../../../shared/cgp-grid/base-cgp-grid.template';

@Component({
    selector: 'mesc-groups',
    templateUrl: './groups.component.html',
    // styleUrls: ['./groups.component.scss']
})
export class GroupsComponent extends BaseGridTemplate implements OnInit {

    constructor(
        private service: GroupService,
        private moduleService: ModuleService,
        private formBuilder: FormBuilder,
    ) { super(); }


    ngOnInit(): void {
        // this.moduleService.query();
    }


    handleRead = (force) => {
        return Promise.all([
            this.moduleService.read(),
            this.service.read(),
        ])
            .then(data => data[1])
    }


    setModelHandler() {
        this.editDataItem = new Group();
    }


    columns = [
        {
            field: "Name",
            title: "Name",
            width: "185"
        }, {
            field: "Description",
            title: "Description"
        }, {
            field: "ModuleId",
            title: "Module",
            width: "135",
            template: {
                type: 'filter',
                pipe: 'nameById',
                dataSource: this.moduleService,
            }
        }
    ];

    editForm = this.formBuilder.group({
        Id: [],
        Name: [Validators.required],
        Description: [Validators.required],
        ModuleId: [Validators.required],
    });

    template = {
        controls: {
            add: true,
            edit: true,
            delete: true,
            excel: false,
        },
        columns: this.columns,
        service: this.service,
        groupable: true,
        read: this.handleRead
    }

    formDialog = {
        title: "Group",
        formControls: [{
            type: "text",
            name: "Name",
            title: "Name",
            readonly: "never",
        }, {
            type: "text",
            name: "Description",
            title: "Description",
            readonly: "never",
        }, {
            type: "combobox",
            readonly: "never",
            name: "ModuleId",
            title: "Module",
            textField: 'Name',
            valueField: 'Id',
            placeholder: 'Select module...',
            service: this.moduleService,
        }
        ],
    }

}
